import React, { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

export const JobCategoryCombobox = ({
  value,
  onChange,
  groups = [],
  items = [],
  testid = "job-category-combobox",
  placeholder = "Choose the role you are looking for",
}) => {
  const [open, setOpen] = useState(false);
  const flatGroups =
    groups.length > 0
      ? groups
      : items.length > 0
      ? [{ group: "All roles", items }]
      : [];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid={testid}
          className={cn(
            "w-full justify-between font-normal border-input bg-background hover:bg-background",
            !value && "text-muted-foreground"
          )}
        >
          <span className="truncate">{value || placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-[--radix-popover-trigger-width] p-0"
        align="start"
      >
        <Command>
          <CommandInput
            placeholder="Type to search roles…"
            data-testid={`${testid}-search`}
          />
          <CommandList className="max-h-72">
            <CommandEmpty>
              No role found — choose "Other (please specify)".
            </CommandEmpty>
            {flatGroups.map((g) => (
              <CommandGroup
                key={g.group}
                heading={g.group}
                className="[&_[cmdk-group-heading]]:text-[11px] [&_[cmdk-group-heading]]:uppercase [&_[cmdk-group-heading]]:tracking-[0.14em] [&_[cmdk-group-heading]]:text-brand-700"
              >
                {g.items.map((c) => (
                  <CommandItem
                    key={c}
                    value={c}
                    onSelect={() => {
                      onChange(c);
                      setOpen(false);
                    }}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        value === c ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {c}
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
